<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=600 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold {{ $t('google_review_link') }}
      v-spacer
      v-btn(icon color="neutral700" @click="closeDialog")
        v-icon mdi-close
    v-divider
    div.py-6.px-10
      v-card.pa-4.round-lg.neutral300(outlined)
        .text-md.mb-5 {{ $t('how_to_find_google_review_link') }}
        ol.pl-4
          li.text-sm.mb-5 Go to your Business Profile. 
            span.font-semibold.clickable(@click="onClickLearnFindProfile") Learn how to find your profile.
          li.text-sm.mb-5 Select 
            span.font-semibold Customers > Reviews > Get more reviews.
            div
              span.font-semibold Tip: 
              span On your computer, using Google Search, select Ask for reviews.
          li.text-sm.mb-1 Your review link should look like this:
            div https://g.page/r/xxxxxxxxxxxxx/review
      .form
        v-form(ref="form")
          v-row(no-gutters)
            //- Subject line
            v-col
              .text-md.neutral500--text.font-semibold.mt-6 {{ $t('paste_google_review_link') }}
              v-text-field.text-md.font-normal.my-2.round-xl(v-model="googleReviewUrlInput" :placeholder="$t('google_review_link_placeholder')" outlined hide-details="auto" :rules="rules.not_empty")
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="$emit('back')") {{ $t('back') }} 
      v-spacer
      v-btn.button-md(@click="nextAction" :loading="isLoading" color="neutral700" :disabled="!canProceed" :dark="canProceed" depressed) {{ $t('connect') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ReviewAddGoogleReviewLinkDialog',
  props: {
    open: {
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: false,
      googleReviewUrlInput: null,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      gmbAccounts: 'review/getGmbAccounts'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    canProceed() {
      if (!this.googleReviewUrlInput) {
        return false
      }
      return this.googleReviewUrlInput.length > 0
    },
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    },
    onClickLearnFindProfile () {
      window.open('https://support.google.com/business/answer/145585?sjid=10213121503988633481-AP#number_1', '_blank')
    },
    async nextAction() {
      this.isLoading = true
      await this.save()
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        await this.$axios.patch(`reviews/${this.company.slug}`, { google_review_url: this.googleReviewUrlInput })
        this.$store.commit('review/setGoogleReviewUrl', this.googleReviewUrlInput)
        this.$emit('next')
      } catch (error) {
        // Handling invalid url error
        if (error?.response?.status === 400 && error?.response?.data?.non_field_errors) {
          if (error?.response?.data?.non_field_errors.length > 0 && error?.response?.data?.non_field_errors.some(item => item === 'Invalid Google review URL')) {
            this.showMessage(['error', this.$t('error_message.url_invalid')])
            this.isLoading = false
            return
          }
        }
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    }
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.no-padding-x {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.selected-button {
  background: #EEEEEE !important;
  border-radius: 16px;
}
::v-deep svg.v-icon.notranslate.v-data-table-header__icon {
  height: 8px !important;
  width: 8px !important;
  margin-left: 8px;
}
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.pre-wrap {
  white-space: pre-wrap;
}
.sticky {
  top: 1%;
  position: sticky;
}
</style>